import { isbot } from "isbot";

export function isBotUserAgent() {
  return typeof navigator === "undefined" ? false : isbot(navigator.userAgent);
}
